function initVendedoresGate() {
    const gate = document.getElementById('vendedoresGate');
    if (!gate || gate.hidden) return;

    const form = gate.querySelector('#vendedoresGateForm');
    const input = gate.querySelector('#vendorPassword');
    const statusEl = gate.querySelector('#vendedoresGateStatus');
    const button = gate.querySelector('.vendedores-gate__button');

    if (!form || !input || !button || !statusEl) return;

    // Guard against attaching listeners more than once on the same element
    if (form._gateReady) return;
    form._gateReady = true;

    function getPassword() {
        return (gate.dataset.vendorPassword || '').trim();
    }

    function showError(message) {
        statusEl.hidden = false;
        statusEl.setAttribute('data-tone', 'error');
        statusEl.textContent = message;
    }

    function hideGate() {
        gate.classList.add('vendedores-gate--hidden');
        // Fallback in case transitionend never fires (animations disabled, etc.)
        const timer = setTimeout(function () {
            gate.hidden = true;
        }, 500);
        gate.addEventListener('transitionend', function () {
            clearTimeout(timer);
            gate.hidden = true;
        }, { once: true });
    }

    function validate() {
        const entered = (input.value || '').trim();
        const correct = getPassword();

        if (!entered) {
            showError('Ingresa la contraseña.');
            input.focus();
            return;
        }

        if (entered === correct) {
            try {
                sessionStorage.setItem('vendor_catalog_auth', 'ok');
            } catch (e) {
                // Proceed anyway — gate hides for this page load
            }
            statusEl.hidden = true;
            hideGate();
        } else {
            showError('Contraseña incorrecta. Intenta nuevamente.');
            input.value = '';
            input.focus();
        }
    }

    // Primary: button click
    button.addEventListener('click', function (event) {
        event.preventDefault();
        validate();
    });

    // Secondary: Enter key in the input
    input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            validate();
        }
    });

    // Tertiary: form submit event (covers browser-specific paths)
    form.addEventListener('submit', function (event) {
        event.preventDefault();
        validate();
    });
}

// Run on initial page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVendedoresGate, { once: true });
} else {
    initVendedoresGate();
}

// Re-initialize after Shopify theme editor re-renders the section
document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('#vendedoresGate')) {
        initVendedoresGate();
    }
});
